import { useEffect, useRef } from 'react';

interface LoadScriptProps {
  async?: boolean;
  defer?: boolean;
  onError?: () => void;
  onload?: ((this: GlobalEventHandlers, ev: Event) => any) | null;
  src: string;
  type?: 'module' | 'text/javascript';
}

const LoadScript = ({
  async = true,
  defer = false,
  onError,
  onload = null,
  src,
  type = 'text/javascript',
}: LoadScriptProps) => {
  const onloadRef = useRef(onload);
  onloadRef.current = onload;
  const onErrorRef = useRef(onError);
  onErrorRef.current = onError;

  useEffect(() => {
    if (document.querySelector(`script[src="${src}"]`)) {
      return undefined;
    }

    const script = document.createElement('script');
    script.src = src;
    script.async = async;
    script.type = type;
    script.defer = defer;
    script.onload = function (ev) {
      onloadRef.current?.call(this, ev);
    };
    document.body.appendChild(script);

    script.onerror = () => {
      onErrorRef.current?.();
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };

    return () => {
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, [src, async, type, defer]);

  return null;
};

export default LoadScript;
